import {Component} from "@angular/core";

@Component({
    selector: 'tfl-chevron-right',
    template: `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path fill="#616161" fill-rule="evenodd" d="M9.877 16.617a.328.328 0 0 1-.51 0 .465.465 0 0 1 0-.59l4.491-4.288-4.491-4.287a.465.465 0 0 1 0-.59.327.327 0 0 1 .51 0l4.756 4.581a.465.465 0 0 1 0 .591l-4.756 4.583z"/>
        </svg>
    `
})
export class ChevronRightIcon {

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/icons/chevron-right.icon.ts